document.addEventListener('DOMContentLoaded', function () {

    document.body.addEventListener('change', function (event) {
        if (event.target.matches('.quantity__input')) {
            const variantId = event.target.getAttribute('data-quantity-variant-id');
            const newQuantity = event.target.value;
            updateCartItem(variantId, newQuantity);
        }
    });

    document.body.addEventListener('click', function (event) {
        const removeButton = event.target.closest('.button--tertiary');
        if (removeButton) {
            event.preventDefault();
            const href = removeButton.getAttribute('href');
            const variantId = new URLSearchParams(href.split('?')[1]).get('id').split(':')[0];
            updateCartItem(variantId, 0);
        }
    });
});

// Function to update cart item using Shopify's AJAX API and reload the page
async function updateCartItem(variantId, quantity) {
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: parseInt(quantity, 10)
            })
        });

        const updatedCart = await response.json();
        if (updatedCart.status === 'bad_request') {
            console.error('Error updating cart:', updatedCart.message);
            return;
        }

        // Reload the page after the cart is successfully updated
        window.location.reload();

    } catch (error) {
        console.error('Error updating cart:', error);
    }
}

// Function to dynamically update the button and tooltip message
function updateCheckoutButtonState(weight_check_failed, failed_messages) {
    const checkoutButtons = document.querySelectorAll('.cart__checkout-button, .cart-checkout-button');
    const tooltipMessages = document.querySelectorAll('.tooltip-message');
    const dynamicCheckoutButtons = document.querySelector('.cart__dynamic-checkout-buttons');

    if (checkoutButtons) {
        if (weight_check_failed) {
            checkoutButtons.forEach(checkoutButton => {
                checkoutButton.classList.add('button--disabled');
                checkoutButton.setAttribute('disabled', true);
            });
                tooltipMessages.forEach(tooltipMessage => {
                    if (tooltipMessage) {
                        tooltipMessage.innerText = failed_messages.join('\n');
                        tooltipMessage.style.visibility = 'visible';
                    }
                });
                if (dynamicCheckoutButtons) {
                    dynamicCheckoutButtons.style.display = 'none';
                }
            } else {
            checkoutButtons.forEach(checkoutButton => {
                checkoutButton.classList.remove('button--disabled');
                checkoutButton.removeAttribute('disabled');
            });
            tooltipMessages.forEach(tooltipMessage => {
                if (tooltipMessage) {
                    tooltipMessage.innerText = '';
                    tooltipMessage.style.visibility = 'hidden';
                }
            });
                if (dynamicCheckoutButtons) {
                    dynamicCheckoutButtons.style.display = 'block';
                }

            }
    }
}

// Function to check the total cart weight and quantity multiples
async function checkCartWeight() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        let weight_check_failed = false;
        let failed_messages = [];
        let collectionWeights = {};
        let collectionQuantities = {};

        cart.items.forEach(item => {
            const itemCollections = productCollections[item.id];

            dogFoodCollections.forEach(collection => {
                const collection_handle = collection.collection_handle.toLowerCase();
                const lowerCaseItemCollections = itemCollections.map(coll => coll.toLowerCase());
                const collectionMatch = lowerCaseItemCollections.includes(collection_handle);
                const collectionCustomerTags = collection.customer_tags.split(',').map(tag => tag.trim().toLowerCase());
                const customerTagsLower = customerTags.map(tag => tag.toLowerCase());
                const customerTagMatch = collectionCustomerTags.every(tag => tag.trim() === "") || collectionCustomerTags.some(tag => customerTagsLower.includes(tag.trim()));

                if (collectionMatch && customerTagMatch) {
                    if (!collectionWeights[collection_handle]) {
                        collectionWeights[collection_handle] = 0;
                    }
                    if (!collectionQuantities[collection_handle]) {
                        collectionQuantities[collection_handle] = 0;
                    }

                    const item_weight = item.grams * item.quantity;
                    collectionWeights[collection_handle] += item_weight;
                    collectionQuantities[collection_handle] += item.quantity;
                }
            });
        });

        dogFoodCollections.forEach(collection => {
            const collection_handle = collection.collection_handle.toLowerCase();
          
            if (collection_handle == 'natural-dog-treats' && collection.use_custom_treats_rule == "true" && collectionWeights[collection_handle] && (collectionWeights['raw-frozen-dog-food'] > 0 || collectionWeights['cold-pressed-dog-food-1'] > 0)){
                let cold_pressed_weight_value = 30.0;
                let raw_weight_value = 48.0;
                if ((collectionWeights['raw-frozen-dog-food'] ?? 0) < 48000 && (collectionWeights['cold-pressed-dog-food-1'] ?? 0) < 30000){
                  weight_check_failed = true;
                  failed_messages.push(
                      `Minimum Order Quantity of ${raw_weight_value}KG Raw Frozen OR ${cold_pressed_weight_value}KG Cold Pressed Required for Natural Dog Treats`
                  );
                }
            }
          
            else if (collectionWeights[collection_handle]) {
                let weight_value = parseFloat(collection.minimum_collection_weight);
                if (collection.minimum_collection_weight_unit === "kg") {
                    weight_value *= 1000;
                }

                if (collectionWeights[collection_handle] < weight_value) {
                    weight_check_failed = true;
                    failed_messages.push(
                        `Minimum Order Quantity of ${collection.minimum_collection_weight}KG Required for ${collection.collection_name || collection.collection_handle}`
                    );
                }

                if (Boolean(collection.requires_multiples) && collection.requires_multiples == "true") {
                    const multipleValue = parseInt(collection.quantity_for_multiples, 10);
                    if (collectionQuantities[collection_handle] % multipleValue !== 0) {
                        weight_check_failed = true;
                        failed_messages.push(
                            `Total Quantity of ${collection.collection_name || collection.collection_handle} must be a multiple of ${multipleValue}`
                        );
                    }
                }
            }
        });

        updateCheckoutButtonState(weight_check_failed, failed_messages);

    } catch (error) {
        console.error('Error fetching cart data:', error);
    }
}

checkCartWeight();



